module.exports = __webpack_public_path__ + "img/banner_wide_1920x256_5G.e6b43013.jpg";